import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";

export const changePassword = (currentPassword, newPassword) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.post(
        `${apiConstants().AUTH_API_URL}api/v1/auth/change-password`,
        {
          currentPassword: currentPassword,
          newPassword: newPassword
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.errors) {
        toaster("error", err.response.data.errors[0]);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};
